export const data = [
  {
    _year: "2015-2016",
    month: "April",
    product: "DAP",
    state: "Andaman & Nicobar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MAP",
    state: "Andaman & Nicobar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 2,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MOP",
    state: "Andaman & Nicobar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 3,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "NPK",
    state: "Andaman & Nicobar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 4,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "TSP",
    state: "Andaman & Nicobar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 5,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "UREA",
    state: "Andaman & Nicobar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 6,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "SSP",
    state: "Andaman & Nicobar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 7,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "DAP",
    state: "Andhra Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "4466.62",
    id: 8,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MAP",
    state: "Andhra Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 9,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MOP",
    state: "Andhra Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "17390.15",
    id: 10,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "NPK",
    state: "Andhra Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "35807.34",
    id: 11,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "TSP",
    state: "Andhra Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 12,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "UREA",
    state: "Andhra Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "8843.6",
    id: 13,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "SSP",
    state: "Andhra Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 14,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "DAP",
    state: "Arunachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 15,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MAP",
    state: "Arunachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 16,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MOP",
    state: "Arunachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 17,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "NPK",
    state: "Arunachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 18,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "TSP",
    state: "Arunachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 19,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "UREA",
    state: "Arunachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 20,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "SSP",
    state: "Arunachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 21,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "DAP",
    state: "Assam",
    requirement_in_mt_: "0",
    availability_in_mt_: "3885.1",
    id: 22,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MAP",
    state: "Assam",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 23,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MOP",
    state: "Assam",
    requirement_in_mt_: "0",
    availability_in_mt_: "11247.8",
    id: 24,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "NPK",
    state: "Assam",
    requirement_in_mt_: "0",
    availability_in_mt_: "1443.9",
    id: 25,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "TSP",
    state: "Assam",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 26,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "UREA",
    state: "Assam",
    requirement_in_mt_: "0",
    availability_in_mt_: "2479.2",
    id: 27,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "SSP",
    state: "Assam",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 28,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "DAP",
    state: "Bihar",
    requirement_in_mt_: "0",
    availability_in_mt_: "5236.35",
    id: 29,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MAP",
    state: "Bihar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 30,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MOP",
    state: "Bihar",
    requirement_in_mt_: "0",
    availability_in_mt_: "22863.05",
    id: 31,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "NPK",
    state: "Bihar",
    requirement_in_mt_: "0",
    availability_in_mt_: "21715.9",
    id: 32,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "TSP",
    state: "Bihar",
    requirement_in_mt_: "0",
    availability_in_mt_: "7673.75",
    id: 33,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "UREA",
    state: "Bihar",
    requirement_in_mt_: "0",
    availability_in_mt_: "2378.7",
    id: 34,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "SSP",
    state: "Bihar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 35,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "DAP",
    state: "Chandigarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 36,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MAP",
    state: "Chandigarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 37,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MOP",
    state: "Chandigarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 38,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "NPK",
    state: "Chandigarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 39,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "TSP",
    state: "Chandigarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 40,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "UREA",
    state: "Chandigarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 41,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "SSP",
    state: "Chandigarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 42,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "DAP",
    state: "Chattishgarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "678.8",
    id: 43,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MAP",
    state: "Chattishgarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 44,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MOP",
    state: "Chattishgarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "9159.5",
    id: 45,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "NPK",
    state: "Chattishgarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "7305.84",
    id: 46,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "TSP",
    state: "Chattishgarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "3858.25",
    id: 47,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "UREA",
    state: "Chattishgarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "4268.6",
    id: 48,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "SSP",
    state: "Chattishgarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 49,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "DAP",
    state: "Dadra & Nagar Haveli",
    requirement_in_mt_: "0",
    availability_in_mt_: "25.3",
    id: 50,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MAP",
    state: "Dadra & Nagar Haveli",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 51,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MOP",
    state: "Dadra & Nagar Haveli",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 52,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "NPK",
    state: "Dadra & Nagar Haveli",
    requirement_in_mt_: "0",
    availability_in_mt_: "0.9",
    id: 53,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "TSP",
    state: "Dadra & Nagar Haveli",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 54,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "UREA",
    state: "Dadra & Nagar Haveli",
    requirement_in_mt_: "0",
    availability_in_mt_: "20.2",
    id: 55,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "SSP",
    state: "Dadra & Nagar Haveli",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 56,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "DAP",
    state: "Delhi",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 57,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MAP",
    state: "Delhi",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 58,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MOP",
    state: "Delhi",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 59,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "NPK",
    state: "Delhi",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 60,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "TSP",
    state: "Delhi",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 61,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "UREA",
    state: "Delhi",
    requirement_in_mt_: "300",
    availability_in_mt_: "0",
    id: 62,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "SSP",
    state: "Delhi",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 63,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "DAP",
    state: "Goa",
    requirement_in_mt_: "0",
    availability_in_mt_: "18.5",
    id: 64,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MAP",
    state: "Goa",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 65,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MOP",
    state: "Goa",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 66,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "NPK",
    state: "Goa",
    requirement_in_mt_: "0",
    availability_in_mt_: "16.7",
    id: 67,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "TSP",
    state: "Goa",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 68,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "UREA",
    state: "Goa",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 69,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "SSP",
    state: "Goa",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 70,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "DAP",
    state: "Gujarat",
    requirement_in_mt_: "0",
    availability_in_mt_: "21837.68",
    id: 71,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MAP",
    state: "Gujarat",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 72,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MOP",
    state: "Gujarat",
    requirement_in_mt_: "0",
    availability_in_mt_: "2988.95",
    id: 73,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "NPK",
    state: "Gujarat",
    requirement_in_mt_: "0",
    availability_in_mt_: "32830.96",
    id: 74,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "TSP",
    state: "Gujarat",
    requirement_in_mt_: "0",
    availability_in_mt_: "6313.85",
    id: 75,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "UREA",
    state: "Gujarat",
    requirement_in_mt_: "0",
    availability_in_mt_: "5271.79",
    id: 76,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "SSP",
    state: "Gujarat",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 77,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "DAP",
    state: "Harayana",
    requirement_in_mt_: "0",
    availability_in_mt_: "15031",
    id: 78,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MAP",
    state: "Harayana",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 79,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MOP",
    state: "Harayana",
    requirement_in_mt_: "0",
    availability_in_mt_: "10070.05",
    id: 80,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "NPK",
    state: "Harayana",
    requirement_in_mt_: "0",
    availability_in_mt_: "1041.05",
    id: 81,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "TSP",
    state: "Harayana",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 82,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "UREA",
    state: "Harayana",
    requirement_in_mt_: "0",
    availability_in_mt_: "3274.75",
    id: 83,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "SSP",
    state: "Harayana",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 84,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "DAP",
    state: "Himachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 85,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MAP",
    state: "Himachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 86,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MOP",
    state: "Himachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 87,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "NPK",
    state: "Himachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "35.55",
    id: 88,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "TSP",
    state: "Himachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 89,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "UREA",
    state: "Himachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "64.7",
    id: 90,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "SSP",
    state: "Himachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 91,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "DAP",
    state: "Jammu & Kashmir",
    requirement_in_mt_: "0",
    availability_in_mt_: "9600.5",
    id: 92,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MAP",
    state: "Jammu & Kashmir",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 93,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MOP",
    state: "Jammu & Kashmir",
    requirement_in_mt_: "0",
    availability_in_mt_: "5775.85",
    id: 94,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "NPK",
    state: "Jammu & Kashmir",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 95,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "TSP",
    state: "Jammu & Kashmir",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 96,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "UREA",
    state: "Jammu & Kashmir",
    requirement_in_mt_: "0",
    availability_in_mt_: "771.9",
    id: 97,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "SSP",
    state: "Jammu & Kashmir",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 98,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "DAP",
    state: "Jharkhand",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 99,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MAP",
    state: "Jharkhand",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 100,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MOP",
    state: "Jharkhand",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 101,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "NPK",
    state: "Jharkhand",
    requirement_in_mt_: "0",
    availability_in_mt_: "71.25",
    id: 102,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "TSP",
    state: "Jharkhand",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 103,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "UREA",
    state: "Jharkhand",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 104,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "SSP",
    state: "Jharkhand",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 105,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "DAP",
    state: "Karnataka",
    requirement_in_mt_: "40000",
    availability_in_mt_: "2424.45",
    id: 106,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MAP",
    state: "Karnataka",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 107,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MOP",
    state: "Karnataka",
    requirement_in_mt_: "30000",
    availability_in_mt_: "31619.3",
    id: 108,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "NPK",
    state: "Karnataka",
    requirement_in_mt_: "60050",
    availability_in_mt_: "50987.02",
    id: 109,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "TSP",
    state: "Karnataka",
    requirement_in_mt_: "0",
    availability_in_mt_: "11905.4",
    id: 110,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "UREA",
    state: "Karnataka",
    requirement_in_mt_: "100000",
    availability_in_mt_: "9793.299999999999",
    id: 111,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "SSP",
    state: "Karnataka",
    requirement_in_mt_: "20000",
    availability_in_mt_: "0",
    id: 112,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "DAP",
    state: "Kerala",
    requirement_in_mt_: "0",
    availability_in_mt_: "779.9",
    id: 113,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MAP",
    state: "Kerala",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 114,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MOP",
    state: "Kerala",
    requirement_in_mt_: "0",
    availability_in_mt_: "1217.34",
    id: 115,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "NPK",
    state: "Kerala",
    requirement_in_mt_: "0",
    availability_in_mt_: "9924.059999999999",
    id: 116,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "TSP",
    state: "Kerala",
    requirement_in_mt_: "0",
    availability_in_mt_: "3156.75",
    id: 117,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "UREA",
    state: "Kerala",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 118,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "SSP",
    state: "Kerala",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 119,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "DAP",
    state: "Madhya Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "7565.37",
    id: 120,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MAP",
    state: "Madhya Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 121,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MOP",
    state: "Madhya Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "16131.1",
    id: 122,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "NPK",
    state: "Madhya Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "24626.7",
    id: 123,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "TSP",
    state: "Madhya Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "8443.85",
    id: 124,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "UREA",
    state: "Madhya Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "2615.6",
    id: 125,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "SSP",
    state: "Madhya Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 126,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "DAP",
    state: "Maharastra",
    requirement_in_mt_: "0",
    availability_in_mt_: "2574.62",
    id: 127,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MAP",
    state: "Maharastra",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 128,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MOP",
    state: "Maharastra",
    requirement_in_mt_: "0",
    availability_in_mt_: "41732.82",
    id: 129,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "NPK",
    state: "Maharastra",
    requirement_in_mt_: "0",
    availability_in_mt_: "84783.10000000001",
    id: 130,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "TSP",
    state: "Maharastra",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 131,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "UREA",
    state: "Maharastra",
    requirement_in_mt_: "0",
    availability_in_mt_: "9545.549999999999",
    id: 132,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "SSP",
    state: "Maharastra",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 133,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "DAP",
    state: "Manipur",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 134,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MAP",
    state: "Manipur",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 135,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MOP",
    state: "Manipur",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 136,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "NPK",
    state: "Manipur",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 137,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "TSP",
    state: "Manipur",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 138,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "UREA",
    state: "Manipur",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 139,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "SSP",
    state: "Manipur",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 140,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "DAP",
    state: "Megalaya",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 141,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MAP",
    state: "Megalaya",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 142,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MOP",
    state: "Megalaya",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 143,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "NPK",
    state: "Megalaya",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 144,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "TSP",
    state: "Megalaya",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 145,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "UREA",
    state: "Megalaya",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 146,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "SSP",
    state: "Megalaya",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 147,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "DAP",
    state: "Mizoram",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 148,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MAP",
    state: "Mizoram",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 149,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MOP",
    state: "Mizoram",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 150,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "NPK",
    state: "Mizoram",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 151,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "TSP",
    state: "Mizoram",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 152,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "UREA",
    state: "Mizoram",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 153,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "SSP",
    state: "Mizoram",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 154,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "DAP",
    state: "Nagaland",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 155,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MAP",
    state: "Nagaland",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 156,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MOP",
    state: "Nagaland",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 157,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "NPK",
    state: "Nagaland",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 158,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "TSP",
    state: "Nagaland",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 159,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "UREA",
    state: "Nagaland",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 160,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "SSP",
    state: "Nagaland",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 161,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "DAP",
    state: "Orissa",
    requirement_in_mt_: "0",
    availability_in_mt_: "1663.9",
    id: 162,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MAP",
    state: "Orissa",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 163,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MOP",
    state: "Orissa",
    requirement_in_mt_: "0",
    availability_in_mt_: "4103.75",
    id: 164,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "NPK",
    state: "Orissa",
    requirement_in_mt_: "0",
    availability_in_mt_: "3448.85",
    id: 165,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "TSP",
    state: "Orissa",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 166,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "UREA",
    state: "Orissa",
    requirement_in_mt_: "0",
    availability_in_mt_: "2297.7",
    id: 167,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "SSP",
    state: "Orissa",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 168,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "DAP",
    state: "Pondicherry",
    requirement_in_mt_: "0",
    availability_in_mt_: "56",
    id: 169,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MAP",
    state: "Pondicherry",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 170,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MOP",
    state: "Pondicherry",
    requirement_in_mt_: "0",
    availability_in_mt_: "129.15",
    id: 171,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "NPK",
    state: "Pondicherry",
    requirement_in_mt_: "0",
    availability_in_mt_: "727.8",
    id: 172,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "TSP",
    state: "Pondicherry",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 173,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "UREA",
    state: "Pondicherry",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 174,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "SSP",
    state: "Pondicherry",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 175,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "DAP",
    state: "Punjab",
    requirement_in_mt_: "0",
    availability_in_mt_: "16251.1",
    id: 176,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MAP",
    state: "Punjab",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 177,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MOP",
    state: "Punjab",
    requirement_in_mt_: "0",
    availability_in_mt_: "10450.5",
    id: 178,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "NPK",
    state: "Punjab",
    requirement_in_mt_: "0",
    availability_in_mt_: "847.45",
    id: 179,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "TSP",
    state: "Punjab",
    requirement_in_mt_: "0",
    availability_in_mt_: "3355.3",
    id: 180,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "UREA",
    state: "Punjab",
    requirement_in_mt_: "0",
    availability_in_mt_: "1060.4",
    id: 181,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "SSP",
    state: "Punjab",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 182,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "DAP",
    state: "Rajasthan",
    requirement_in_mt_: "0",
    availability_in_mt_: "1457.25",
    id: 183,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MAP",
    state: "Rajasthan",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 184,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MOP",
    state: "Rajasthan",
    requirement_in_mt_: "0",
    availability_in_mt_: "3981.5",
    id: 185,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "NPK",
    state: "Rajasthan",
    requirement_in_mt_: "0",
    availability_in_mt_: "1302.1",
    id: 186,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "TSP",
    state: "Rajasthan",
    requirement_in_mt_: "0",
    availability_in_mt_: "3526.25",
    id: 187,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "UREA",
    state: "Rajasthan",
    requirement_in_mt_: "0",
    availability_in_mt_: "2042.3",
    id: 188,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "SSP",
    state: "Rajasthan",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 189,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "DAP",
    state: "Tamil Nadu",
    requirement_in_mt_: "0",
    availability_in_mt_: "3317",
    id: 190,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MAP",
    state: "Tamil Nadu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 191,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MOP",
    state: "Tamil Nadu",
    requirement_in_mt_: "0",
    availability_in_mt_: "8391.65",
    id: 192,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "NPK",
    state: "Tamil Nadu",
    requirement_in_mt_: "0",
    availability_in_mt_: "21415.57",
    id: 193,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "TSP",
    state: "Tamil Nadu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 194,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "UREA",
    state: "Tamil Nadu",
    requirement_in_mt_: "0",
    availability_in_mt_: "675.1799999999999",
    id: 195,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "SSP",
    state: "Tamil Nadu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 196,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "DAP",
    state: "Tripura",
    requirement_in_mt_: "0",
    availability_in_mt_: "3.55",
    id: 197,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MAP",
    state: "Tripura",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 198,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MOP",
    state: "Tripura",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 199,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "NPK",
    state: "Tripura",
    requirement_in_mt_: "0",
    availability_in_mt_: "5.65",
    id: 200,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "TSP",
    state: "Tripura",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 201,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "UREA",
    state: "Tripura",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 202,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "SSP",
    state: "Tripura",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 203,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "DAP",
    state: "Telangana",
    requirement_in_mt_: "20000",
    availability_in_mt_: "3437.25",
    id: 204,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MAP",
    state: "Telangana",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 205,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MOP",
    state: "Telangana",
    requirement_in_mt_: "5000",
    availability_in_mt_: "8116.49",
    id: 206,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "NPK",
    state: "Telangana",
    requirement_in_mt_: "50000",
    availability_in_mt_: "24405.7",
    id: 207,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "TSP",
    state: "Telangana",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 208,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "UREA",
    state: "Telangana",
    requirement_in_mt_: "90000",
    availability_in_mt_: "11584.25",
    id: 209,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "SSP",
    state: "Telangana",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 210,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "DAP",
    state: "Uttar Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "50872.68",
    id: 211,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MAP",
    state: "Uttar Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 212,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MOP",
    state: "Uttar Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "32315.5",
    id: 213,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "NPK",
    state: "Uttar Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "28696.65",
    id: 214,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "TSP",
    state: "Uttar Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "16125.25",
    id: 215,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "UREA",
    state: "Uttar Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "60286.7",
    id: 216,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "SSP",
    state: "Uttar Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 217,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "DAP",
    state: "Uttaranchal",
    requirement_in_mt_: "0",
    availability_in_mt_: "443.55",
    id: 218,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MAP",
    state: "Uttaranchal",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 219,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MOP",
    state: "Uttaranchal",
    requirement_in_mt_: "0",
    availability_in_mt_: "16.25",
    id: 220,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "NPK",
    state: "Uttaranchal",
    requirement_in_mt_: "0",
    availability_in_mt_: "3370",
    id: 221,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "TSP",
    state: "Uttaranchal",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 222,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "UREA",
    state: "Uttaranchal",
    requirement_in_mt_: "0",
    availability_in_mt_: "1869.7",
    id: 223,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "SSP",
    state: "Uttaranchal",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 224,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "DAP",
    state: "West Bengal",
    requirement_in_mt_: "0",
    availability_in_mt_: "739.01",
    id: 225,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MAP",
    state: "West Bengal",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 226,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "MOP",
    state: "West Bengal",
    requirement_in_mt_: "0",
    availability_in_mt_: "51674.85",
    id: 227,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "NPK",
    state: "West Bengal",
    requirement_in_mt_: "0",
    availability_in_mt_: "50881.83",
    id: 228,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "TSP",
    state: "West Bengal",
    requirement_in_mt_: "0",
    availability_in_mt_: "7377.55",
    id: 229,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "UREA",
    state: "West Bengal",
    requirement_in_mt_: "0",
    availability_in_mt_: "1008.43",
    id: 230,
  },
  {
    _year: "2015-2016",
    month: "April",
    product: "SSP",
    state: "West Bengal",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 231,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "DAP",
    state: "Andaman & Nicobar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 232,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MAP",
    state: "Andaman & Nicobar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 233,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MOP",
    state: "Andaman & Nicobar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 234,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "NPK",
    state: "Andaman & Nicobar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 235,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "TSP",
    state: "Andaman & Nicobar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 236,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "UREA",
    state: "Andaman & Nicobar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 237,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "SSP",
    state: "Andaman & Nicobar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 238,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "DAP",
    state: "Andhra Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "5617.02",
    id: 239,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MAP",
    state: "Andhra Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 240,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MOP",
    state: "Andhra Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "17702.3",
    id: 241,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "NPK",
    state: "Andhra Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "52981.46",
    id: 242,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "TSP",
    state: "Andhra Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 243,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "UREA",
    state: "Andhra Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "15078.25",
    id: 244,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "SSP",
    state: "Andhra Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 245,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "DAP",
    state: "Arunachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 246,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MAP",
    state: "Arunachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 247,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MOP",
    state: "Arunachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 248,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "NPK",
    state: "Arunachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 249,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "TSP",
    state: "Arunachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 250,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "UREA",
    state: "Arunachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 251,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "SSP",
    state: "Arunachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 252,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "DAP",
    state: "Assam",
    requirement_in_mt_: "0",
    availability_in_mt_: "2110.8",
    id: 253,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MAP",
    state: "Assam",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 254,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MOP",
    state: "Assam",
    requirement_in_mt_: "0",
    availability_in_mt_: "10348.4",
    id: 255,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "NPK",
    state: "Assam",
    requirement_in_mt_: "0",
    availability_in_mt_: "1192.9",
    id: 256,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "TSP",
    state: "Assam",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 257,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "UREA",
    state: "Assam",
    requirement_in_mt_: "0",
    availability_in_mt_: "2322.75",
    id: 258,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "SSP",
    state: "Assam",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 259,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "DAP",
    state: "Bihar",
    requirement_in_mt_: "0",
    availability_in_mt_: "11323.9",
    id: 260,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MAP",
    state: "Bihar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 261,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MOP",
    state: "Bihar",
    requirement_in_mt_: "0",
    availability_in_mt_: "24027.6",
    id: 262,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "NPK",
    state: "Bihar",
    requirement_in_mt_: "0",
    availability_in_mt_: "34337",
    id: 263,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "TSP",
    state: "Bihar",
    requirement_in_mt_: "0",
    availability_in_mt_: "7673.75",
    id: 264,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "UREA",
    state: "Bihar",
    requirement_in_mt_: "0",
    availability_in_mt_: "16041.3",
    id: 265,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "SSP",
    state: "Bihar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 266,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "DAP",
    state: "Chandigarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 267,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MAP",
    state: "Chandigarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 268,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MOP",
    state: "Chandigarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 269,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "NPK",
    state: "Chandigarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 270,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "TSP",
    state: "Chandigarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 271,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "UREA",
    state: "Chandigarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 272,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "SSP",
    state: "Chandigarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 273,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "DAP",
    state: "Chattishgarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "1689.65",
    id: 274,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MAP",
    state: "Chattishgarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 275,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MOP",
    state: "Chattishgarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "18100.95",
    id: 276,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "NPK",
    state: "Chattishgarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "16614.49",
    id: 277,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "TSP",
    state: "Chattishgarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "3858.25",
    id: 278,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "UREA",
    state: "Chattishgarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "10837.65",
    id: 279,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "SSP",
    state: "Chattishgarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 280,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "DAP",
    state: "Dadra & Nagar Haveli",
    requirement_in_mt_: "0",
    availability_in_mt_: "18.55",
    id: 281,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MAP",
    state: "Dadra & Nagar Haveli",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 282,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MOP",
    state: "Dadra & Nagar Haveli",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 283,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "NPK",
    state: "Dadra & Nagar Haveli",
    requirement_in_mt_: "0",
    availability_in_mt_: "16.4",
    id: 284,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "TSP",
    state: "Dadra & Nagar Haveli",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 285,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "UREA",
    state: "Dadra & Nagar Haveli",
    requirement_in_mt_: "0",
    availability_in_mt_: "5.75",
    id: 286,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "SSP",
    state: "Dadra & Nagar Haveli",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 287,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "DAP",
    state: "Daman & Diu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 288,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MAP",
    state: "Daman & Diu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 289,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MOP",
    state: "Daman & Diu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 290,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "NPK",
    state: "Daman & Diu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 291,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "TSP",
    state: "Daman & Diu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 292,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "UREA",
    state: "Daman & Diu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 293,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "SSP",
    state: "Daman & Diu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 294,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "DAP",
    state: "Delhi",
    requirement_in_mt_: "200",
    availability_in_mt_: "0",
    id: 295,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MAP",
    state: "Delhi",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 296,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MOP",
    state: "Delhi",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 297,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "NPK",
    state: "Delhi",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 298,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "TSP",
    state: "Delhi",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 299,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "UREA",
    state: "Delhi",
    requirement_in_mt_: "750",
    availability_in_mt_: "0",
    id: 300,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "SSP",
    state: "Delhi",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 301,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "DAP",
    state: "Goa",
    requirement_in_mt_: "0",
    availability_in_mt_: "28.45",
    id: 302,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MAP",
    state: "Goa",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 303,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MOP",
    state: "Goa",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 304,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "NPK",
    state: "Goa",
    requirement_in_mt_: "0",
    availability_in_mt_: "16.2",
    id: 305,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "TSP",
    state: "Goa",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 306,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "UREA",
    state: "Goa",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 307,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "SSP",
    state: "Goa",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 308,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "DAP",
    state: "Gujarat",
    requirement_in_mt_: "0",
    availability_in_mt_: "13987.33",
    id: 309,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MAP",
    state: "Gujarat",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 310,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MOP",
    state: "Gujarat",
    requirement_in_mt_: "0",
    availability_in_mt_: "2789",
    id: 311,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "NPK",
    state: "Gujarat",
    requirement_in_mt_: "0",
    availability_in_mt_: "47022.21",
    id: 312,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "TSP",
    state: "Gujarat",
    requirement_in_mt_: "0",
    availability_in_mt_: "6313.85",
    id: 313,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "UREA",
    state: "Gujarat",
    requirement_in_mt_: "0",
    availability_in_mt_: "32026.59",
    id: 314,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "SSP",
    state: "Gujarat",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 315,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "DAP",
    state: "Harayana",
    requirement_in_mt_: "0",
    availability_in_mt_: "10694.75",
    id: 316,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MAP",
    state: "Harayana",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 317,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MOP",
    state: "Harayana",
    requirement_in_mt_: "0",
    availability_in_mt_: "7475.7",
    id: 318,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "NPK",
    state: "Harayana",
    requirement_in_mt_: "0",
    availability_in_mt_: "875.95",
    id: 319,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "TSP",
    state: "Harayana",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 320,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "UREA",
    state: "Harayana",
    requirement_in_mt_: "0",
    availability_in_mt_: "14218.35",
    id: 321,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "SSP",
    state: "Harayana",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 322,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "DAP",
    state: "Himachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 323,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MAP",
    state: "Himachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 324,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MOP",
    state: "Himachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 325,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "NPK",
    state: "Himachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "128.85",
    id: 326,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "TSP",
    state: "Himachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 327,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "UREA",
    state: "Himachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "179.3",
    id: 328,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "SSP",
    state: "Himachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 329,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "DAP",
    state: "Jammu & Kashmir",
    requirement_in_mt_: "0",
    availability_in_mt_: "7007.1",
    id: 330,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MAP",
    state: "Jammu & Kashmir",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 331,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MOP",
    state: "Jammu & Kashmir",
    requirement_in_mt_: "0",
    availability_in_mt_: "4522.55",
    id: 332,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "NPK",
    state: "Jammu & Kashmir",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 333,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "TSP",
    state: "Jammu & Kashmir",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 334,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "UREA",
    state: "Jammu & Kashmir",
    requirement_in_mt_: "0",
    availability_in_mt_: "2444.3",
    id: 335,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "SSP",
    state: "Jammu & Kashmir",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 336,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "DAP",
    state: "Jharkhand",
    requirement_in_mt_: "0",
    availability_in_mt_: "471.2",
    id: 337,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MAP",
    state: "Jharkhand",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 338,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MOP",
    state: "Jharkhand",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 339,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "NPK",
    state: "Jharkhand",
    requirement_in_mt_: "0",
    availability_in_mt_: "10250",
    id: 340,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "TSP",
    state: "Jharkhand",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 341,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "UREA",
    state: "Jharkhand",
    requirement_in_mt_: "0",
    availability_in_mt_: "3464.5",
    id: 342,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "SSP",
    state: "Jharkhand",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 343,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "DAP",
    state: "Karnataka",
    requirement_in_mt_: "80000",
    availability_in_mt_: "20386",
    id: 344,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MAP",
    state: "Karnataka",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 345,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MOP",
    state: "Karnataka",
    requirement_in_mt_: "45000",
    availability_in_mt_: "35005.9",
    id: 346,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "NPK",
    state: "Karnataka",
    requirement_in_mt_: "82400",
    availability_in_mt_: "82165.28",
    id: 347,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "TSP",
    state: "Karnataka",
    requirement_in_mt_: "0",
    availability_in_mt_: "11905.4",
    id: 348,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "UREA",
    state: "Karnataka",
    requirement_in_mt_: "120000",
    availability_in_mt_: "24510.9",
    id: 349,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "SSP",
    state: "Karnataka",
    requirement_in_mt_: "25000",
    availability_in_mt_: "0",
    id: 350,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "DAP",
    state: "Kerala",
    requirement_in_mt_: "0",
    availability_in_mt_: "1655.3",
    id: 351,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MAP",
    state: "Kerala",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 352,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MOP",
    state: "Kerala",
    requirement_in_mt_: "0",
    availability_in_mt_: "3296.9",
    id: 353,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "NPK",
    state: "Kerala",
    requirement_in_mt_: "0",
    availability_in_mt_: "19362.92",
    id: 354,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "TSP",
    state: "Kerala",
    requirement_in_mt_: "0",
    availability_in_mt_: "3156.75",
    id: 355,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "UREA",
    state: "Kerala",
    requirement_in_mt_: "0",
    availability_in_mt_: "4230.6",
    id: 356,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "SSP",
    state: "Kerala",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 357,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "DAP",
    state: "Madhya Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "18169.42",
    id: 358,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MAP",
    state: "Madhya Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 359,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MOP",
    state: "Madhya Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "28337.6",
    id: 360,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "NPK",
    state: "Madhya Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "22169.15",
    id: 361,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "TSP",
    state: "Madhya Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "8443.85",
    id: 362,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "UREA",
    state: "Madhya Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "27667.8",
    id: 363,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "SSP",
    state: "Madhya Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 364,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "DAP",
    state: "Maharastra",
    requirement_in_mt_: "0",
    availability_in_mt_: "2546.22",
    id: 365,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MAP",
    state: "Maharastra",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 366,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MOP",
    state: "Maharastra",
    requirement_in_mt_: "0",
    availability_in_mt_: "50842.17",
    id: 367,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "NPK",
    state: "Maharastra",
    requirement_in_mt_: "0",
    availability_in_mt_: "160777.65",
    id: 368,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "TSP",
    state: "Maharastra",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 369,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "UREA",
    state: "Maharastra",
    requirement_in_mt_: "0",
    availability_in_mt_: "33893.1",
    id: 370,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "SSP",
    state: "Maharastra",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 371,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "DAP",
    state: "Manipur",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 372,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MAP",
    state: "Manipur",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 373,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MOP",
    state: "Manipur",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 374,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "NPK",
    state: "Manipur",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 375,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "TSP",
    state: "Manipur",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 376,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "UREA",
    state: "Manipur",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 377,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "SSP",
    state: "Manipur",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 378,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "DAP",
    state: "Megalaya",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 379,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MAP",
    state: "Megalaya",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 380,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MOP",
    state: "Megalaya",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 381,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "NPK",
    state: "Megalaya",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 382,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "TSP",
    state: "Megalaya",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 383,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "UREA",
    state: "Megalaya",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 384,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "SSP",
    state: "Megalaya",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 385,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "DAP",
    state: "Mizoram",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 386,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MAP",
    state: "Mizoram",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 387,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MOP",
    state: "Mizoram",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 388,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "NPK",
    state: "Mizoram",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 389,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "TSP",
    state: "Mizoram",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 390,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "UREA",
    state: "Mizoram",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 391,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "SSP",
    state: "Mizoram",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 392,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "DAP",
    state: "Nagaland",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 393,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MAP",
    state: "Nagaland",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 394,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MOP",
    state: "Nagaland",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 395,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "NPK",
    state: "Nagaland",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 396,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "TSP",
    state: "Nagaland",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 397,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "UREA",
    state: "Nagaland",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 398,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "SSP",
    state: "Nagaland",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 399,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "DAP",
    state: "Orissa",
    requirement_in_mt_: "0",
    availability_in_mt_: "4622.75",
    id: 400,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MAP",
    state: "Orissa",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 401,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MOP",
    state: "Orissa",
    requirement_in_mt_: "0",
    availability_in_mt_: "5326.5",
    id: 402,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "NPK",
    state: "Orissa",
    requirement_in_mt_: "0",
    availability_in_mt_: "20207.05",
    id: 403,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "TSP",
    state: "Orissa",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 404,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "UREA",
    state: "Orissa",
    requirement_in_mt_: "0",
    availability_in_mt_: "8716.85",
    id: 405,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "SSP",
    state: "Orissa",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 406,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "DAP",
    state: "Pondicherry",
    requirement_in_mt_: "0",
    availability_in_mt_: "36",
    id: 407,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MAP",
    state: "Pondicherry",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 408,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MOP",
    state: "Pondicherry",
    requirement_in_mt_: "0",
    availability_in_mt_: "33.15",
    id: 409,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "NPK",
    state: "Pondicherry",
    requirement_in_mt_: "0",
    availability_in_mt_: "636.8",
    id: 410,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "TSP",
    state: "Pondicherry",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 411,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "UREA",
    state: "Pondicherry",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 412,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "SSP",
    state: "Pondicherry",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 413,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "DAP",
    state: "Punjab",
    requirement_in_mt_: "0",
    availability_in_mt_: "18837",
    id: 414,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MAP",
    state: "Punjab",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 415,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MOP",
    state: "Punjab",
    requirement_in_mt_: "0",
    availability_in_mt_: "14253.45",
    id: 416,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "NPK",
    state: "Punjab",
    requirement_in_mt_: "0",
    availability_in_mt_: "2067.95",
    id: 417,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "TSP",
    state: "Punjab",
    requirement_in_mt_: "0",
    availability_in_mt_: "3355.3",
    id: 418,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "UREA",
    state: "Punjab",
    requirement_in_mt_: "0",
    availability_in_mt_: "13641.65",
    id: 419,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "SSP",
    state: "Punjab",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 420,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "DAP",
    state: "Rajasthan",
    requirement_in_mt_: "0",
    availability_in_mt_: "757.7",
    id: 421,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MAP",
    state: "Rajasthan",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 422,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MOP",
    state: "Rajasthan",
    requirement_in_mt_: "0",
    availability_in_mt_: "5645.95",
    id: 423,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "NPK",
    state: "Rajasthan",
    requirement_in_mt_: "0",
    availability_in_mt_: "1209.05",
    id: 424,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "TSP",
    state: "Rajasthan",
    requirement_in_mt_: "0",
    availability_in_mt_: "3526.25",
    id: 425,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "UREA",
    state: "Rajasthan",
    requirement_in_mt_: "0",
    availability_in_mt_: "6186.15",
    id: 426,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "SSP",
    state: "Rajasthan",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 427,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "DAP",
    state: "Tamil Nadu",
    requirement_in_mt_: "0",
    availability_in_mt_: "10466.85",
    id: 428,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MAP",
    state: "Tamil Nadu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 429,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MOP",
    state: "Tamil Nadu",
    requirement_in_mt_: "0",
    availability_in_mt_: "7343.9",
    id: 430,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "NPK",
    state: "Tamil Nadu",
    requirement_in_mt_: "0",
    availability_in_mt_: "28648.07",
    id: 431,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "TSP",
    state: "Tamil Nadu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 432,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "UREA",
    state: "Tamil Nadu",
    requirement_in_mt_: "0",
    availability_in_mt_: "1336.43",
    id: 433,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "SSP",
    state: "Tamil Nadu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 434,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "DAP",
    state: "Tripura",
    requirement_in_mt_: "0",
    availability_in_mt_: "3.55",
    id: 435,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MAP",
    state: "Tripura",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 436,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MOP",
    state: "Tripura",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 437,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "NPK",
    state: "Tripura",
    requirement_in_mt_: "0",
    availability_in_mt_: "5.65",
    id: 438,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "TSP",
    state: "Tripura",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 439,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "UREA",
    state: "Tripura",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 440,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MOP",
    state: "Uttar Pradesh",
    requirement_in_mt_: "25000",
    availability_in_mt_: "38052.2",
    id: 441,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "NPK",
    state: "Uttar Pradesh",
    requirement_in_mt_: "100000",
    availability_in_mt_: "34977.2",
    id: 442,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "TSP",
    state: "Uttar Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "16125.25",
    id: 443,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "UREA",
    state: "Uttar Pradesh",
    requirement_in_mt_: "500000",
    availability_in_mt_: "173946.65",
    id: 444,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "SSP",
    state: "Uttar Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 445,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "DAP",
    state: "Uttaranchal",
    requirement_in_mt_: "0",
    availability_in_mt_: "251.05",
    id: 446,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MAP",
    state: "Uttaranchal",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 447,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MOP",
    state: "Uttaranchal",
    requirement_in_mt_: "0",
    availability_in_mt_: "0.3",
    id: 448,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "NPK",
    state: "Uttaranchal",
    requirement_in_mt_: "0",
    availability_in_mt_: "2814.55",
    id: 449,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "TSP",
    state: "Uttaranchal",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 450,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "UREA",
    state: "Uttaranchal",
    requirement_in_mt_: "0",
    availability_in_mt_: "2401.15",
    id: 451,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "SSP",
    state: "Uttaranchal",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 452,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "DAP",
    state: "West Bengal",
    requirement_in_mt_: "0",
    availability_in_mt_: "2601.01",
    id: 453,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MAP",
    state: "West Bengal",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 454,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "MOP",
    state: "West Bengal",
    requirement_in_mt_: "0",
    availability_in_mt_: "49143.9",
    id: 455,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "NPK",
    state: "West Bengal",
    requirement_in_mt_: "0",
    availability_in_mt_: "96958.92999999999",
    id: 456,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "TSP",
    state: "West Bengal",
    requirement_in_mt_: "0",
    availability_in_mt_: "7377.55",
    id: 457,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "UREA",
    state: "West Bengal",
    requirement_in_mt_: "0",
    availability_in_mt_: "38622.69",
    id: 458,
  },
  {
    _year: "2015-2016",
    month: "May",
    product: "SSP",
    state: "West Bengal",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 459,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "DAP",
    state: "Andaman & Nicobar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 460,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MAP",
    state: "Andaman & Nicobar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 461,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MOP",
    state: "Andaman & Nicobar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 462,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "NPK",
    state: "Andaman & Nicobar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 463,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "TSP",
    state: "Andaman & Nicobar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 464,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "UREA",
    state: "Andaman & Nicobar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 465,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "SSP",
    state: "Andaman & Nicobar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 466,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "DAP",
    state: "Andhra Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "9709.469999999999",
    id: 467,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MAP",
    state: "Andhra Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 468,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MOP",
    state: "Andhra Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "22957.95",
    id: 469,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "NPK",
    state: "Andhra Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "55126.09",
    id: 470,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "TSP",
    state: "Andhra Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 471,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "UREA",
    state: "Andhra Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "23775.8",
    id: 472,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "SSP",
    state: "Andhra Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 473,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "DAP",
    state: "Arunachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 474,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MAP",
    state: "Arunachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 475,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MOP",
    state: "Arunachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 476,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "NPK",
    state: "Arunachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 477,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "TSP",
    state: "Arunachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 478,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "UREA",
    state: "Arunachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 479,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "SSP",
    state: "Arunachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 480,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "DAP",
    state: "Assam",
    requirement_in_mt_: "0",
    availability_in_mt_: "4166.35",
    id: 481,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MAP",
    state: "Assam",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 482,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MOP",
    state: "Assam",
    requirement_in_mt_: "0",
    availability_in_mt_: "4869.05",
    id: 483,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "NPK",
    state: "Assam",
    requirement_in_mt_: "0",
    availability_in_mt_: "1943.7",
    id: 484,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "TSP",
    state: "Assam",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 485,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "UREA",
    state: "Assam",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 486,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "SSP",
    state: "Assam",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 487,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "DAP",
    state: "Bihar",
    requirement_in_mt_: "0",
    availability_in_mt_: "19957.25",
    id: 488,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MAP",
    state: "Bihar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 489,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MOP",
    state: "Bihar",
    requirement_in_mt_: "0",
    availability_in_mt_: "27134.55",
    id: 490,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "NPK",
    state: "Bihar",
    requirement_in_mt_: "0",
    availability_in_mt_: "55313.2",
    id: 491,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "TSP",
    state: "Bihar",
    requirement_in_mt_: "0",
    availability_in_mt_: "7673.75",
    id: 492,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "UREA",
    state: "Bihar",
    requirement_in_mt_: "0",
    availability_in_mt_: "14857.7",
    id: 493,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "SSP",
    state: "Bihar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 494,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "DAP",
    state: "Chandigarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 495,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MAP",
    state: "Chandigarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 496,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MOP",
    state: "Chandigarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 497,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "NPK",
    state: "Chandigarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 498,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "TSP",
    state: "Chandigarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 499,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "UREA",
    state: "Chandigarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 500,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "SSP",
    state: "Chandigarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 501,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "DAP",
    state: "Chattishgarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "6355.3",
    id: 502,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MAP",
    state: "Chattishgarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 503,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MOP",
    state: "Chattishgarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "19689.5",
    id: 504,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "NPK",
    state: "Chattishgarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "14923.89",
    id: 505,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "TSP",
    state: "Chattishgarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "3858.25",
    id: 506,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "UREA",
    state: "Chattishgarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "9044.700000000001",
    id: 507,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "SSP",
    state: "Chattishgarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 508,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "DAP",
    state: "Dadra & Nagar Haveli",
    requirement_in_mt_: "0",
    availability_in_mt_: "2.6",
    id: 509,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MAP",
    state: "Dadra & Nagar Haveli",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 510,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MOP",
    state: "Dadra & Nagar Haveli",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 511,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "NPK",
    state: "Dadra & Nagar Haveli",
    requirement_in_mt_: "0",
    availability_in_mt_: "13.25",
    id: 512,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "TSP",
    state: "Dadra & Nagar Haveli",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 513,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "UREA",
    state: "Dadra & Nagar Haveli",
    requirement_in_mt_: "0",
    availability_in_mt_: "476.8",
    id: 514,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "SSP",
    state: "Dadra & Nagar Haveli",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 515,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "DAP",
    state: "Daman & Diu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 516,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MAP",
    state: "Daman & Diu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 517,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MOP",
    state: "Daman & Diu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 518,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "NPK",
    state: "Daman & Diu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 519,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "TSP",
    state: "Daman & Diu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 520,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "UREA",
    state: "Daman & Diu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 521,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "SSP",
    state: "Daman & Diu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 522,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "DAP",
    state: "Delhi",
    requirement_in_mt_: "400",
    availability_in_mt_: "0",
    id: 523,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MAP",
    state: "Delhi",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 524,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MOP",
    state: "Delhi",
    requirement_in_mt_: "200",
    availability_in_mt_: "0",
    id: 525,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "NPK",
    state: "Delhi",
    requirement_in_mt_: "200",
    availability_in_mt_: "0",
    id: 526,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "TSP",
    state: "Delhi",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 527,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "UREA",
    state: "Delhi",
    requirement_in_mt_: "750",
    availability_in_mt_: "0",
    id: 528,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "SSP",
    state: "Delhi",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 529,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "DAP",
    state: "Goa",
    requirement_in_mt_: "0",
    availability_in_mt_: "21.7",
    id: 530,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MAP",
    state: "Goa",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 531,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MOP",
    state: "Goa",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 532,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "NPK",
    state: "Goa",
    requirement_in_mt_: "0",
    availability_in_mt_: "24.8",
    id: 533,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "TSP",
    state: "Goa",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 534,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "UREA",
    state: "Goa",
    requirement_in_mt_: "0",
    availability_in_mt_: "36",
    id: 535,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "SSP",
    state: "Goa",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 536,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "DAP",
    state: "Gujarat",
    requirement_in_mt_: "0",
    availability_in_mt_: "3088.1",
    id: 537,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MAP",
    state: "Gujarat",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 538,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MOP",
    state: "Gujarat",
    requirement_in_mt_: "0",
    availability_in_mt_: "3120.65",
    id: 539,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "NPK",
    state: "Gujarat",
    requirement_in_mt_: "0",
    availability_in_mt_: "44338.85",
    id: 540,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "TSP",
    state: "Gujarat",
    requirement_in_mt_: "0",
    availability_in_mt_: "6313.85",
    id: 541,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "UREA",
    state: "Gujarat",
    requirement_in_mt_: "0",
    availability_in_mt_: "16308.49",
    id: 542,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "SSP",
    state: "Gujarat",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 543,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "DAP",
    state: "Harayana",
    requirement_in_mt_: "0",
    availability_in_mt_: "11087.2",
    id: 544,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MAP",
    state: "Harayana",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 545,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MOP",
    state: "Harayana",
    requirement_in_mt_: "0",
    availability_in_mt_: "9882.4",
    id: 546,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "NPK",
    state: "Harayana",
    requirement_in_mt_: "0",
    availability_in_mt_: "336.4",
    id: 547,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "TSP",
    state: "Harayana",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 548,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "UREA",
    state: "Harayana",
    requirement_in_mt_: "0",
    availability_in_mt_: "6778.3",
    id: 549,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "SSP",
    state: "Harayana",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 550,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "DAP",
    state: "Himachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 551,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MAP",
    state: "Himachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 552,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MOP",
    state: "Himachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 553,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "NPK",
    state: "Himachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "85.95",
    id: 554,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "TSP",
    state: "Himachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 555,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "UREA",
    state: "Himachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "89.7",
    id: 556,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "SSP",
    state: "Himachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 557,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "DAP",
    state: "Jammu & Kashmir",
    requirement_in_mt_: "0",
    availability_in_mt_: "3525.3",
    id: 558,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MAP",
    state: "Jammu & Kashmir",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 559,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MOP",
    state: "Jammu & Kashmir",
    requirement_in_mt_: "0",
    availability_in_mt_: "4009.75",
    id: 560,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "NPK",
    state: "Jammu & Kashmir",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 561,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "TSP",
    state: "Jammu & Kashmir",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 562,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "UREA",
    state: "Jammu & Kashmir",
    requirement_in_mt_: "0",
    availability_in_mt_: "2273.3",
    id: 563,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "SSP",
    state: "Jammu & Kashmir",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 564,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "DAP",
    state: "Jharkhand",
    requirement_in_mt_: "0",
    availability_in_mt_: "3845.95",
    id: 565,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MAP",
    state: "Jharkhand",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 566,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MOP",
    state: "Jharkhand",
    requirement_in_mt_: "0",
    availability_in_mt_: "0.5",
    id: 567,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "NPK",
    state: "Jharkhand",
    requirement_in_mt_: "0",
    availability_in_mt_: "11485.95",
    id: 568,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "TSP",
    state: "Jharkhand",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 569,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "UREA",
    state: "Jharkhand",
    requirement_in_mt_: "0",
    availability_in_mt_: "5696.3",
    id: 570,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "SSP",
    state: "Jharkhand",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 571,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "DAP",
    state: "Karnataka",
    requirement_in_mt_: "100000",
    availability_in_mt_: "21621.07",
    id: 572,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MAP",
    state: "Karnataka",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 573,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MOP",
    state: "Karnataka",
    requirement_in_mt_: "65000",
    availability_in_mt_: "25842.15",
    id: 574,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "NPK",
    state: "Karnataka",
    requirement_in_mt_: "106100",
    availability_in_mt_: "105851.57",
    id: 575,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "TSP",
    state: "Karnataka",
    requirement_in_mt_: "0",
    availability_in_mt_: "11905.4",
    id: 576,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "UREA",
    state: "Karnataka",
    requirement_in_mt_: "130000",
    availability_in_mt_: "19083.47",
    id: 577,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "SSP",
    state: "Karnataka",
    requirement_in_mt_: "25000",
    availability_in_mt_: "0",
    id: 578,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "DAP",
    state: "Kerala",
    requirement_in_mt_: "0",
    availability_in_mt_: "534.65",
    id: 579,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MAP",
    state: "Kerala",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 580,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MOP",
    state: "Kerala",
    requirement_in_mt_: "0",
    availability_in_mt_: "5819.77",
    id: 581,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "NPK",
    state: "Kerala",
    requirement_in_mt_: "0",
    availability_in_mt_: "18803.97",
    id: 582,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "TSP",
    state: "Kerala",
    requirement_in_mt_: "0",
    availability_in_mt_: "3156.75",
    id: 583,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "UREA",
    state: "Kerala",
    requirement_in_mt_: "0",
    availability_in_mt_: "1429.9",
    id: 584,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "SSP",
    state: "Kerala",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 585,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "DAP",
    state: "Madhya Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "48218.66",
    id: 586,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MAP",
    state: "Madhya Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 587,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MOP",
    state: "Madhya Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "19034.5",
    id: 588,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "NPK",
    state: "Madhya Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "13242.9",
    id: 589,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "TSP",
    state: "Madhya Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "8443.85",
    id: 590,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "UREA",
    state: "Madhya Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "19991.15",
    id: 591,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "SSP",
    state: "Madhya Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 592,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "DAP",
    state: "Maharastra",
    requirement_in_mt_: "0",
    availability_in_mt_: "18114.57",
    id: 593,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MAP",
    state: "Maharastra",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 594,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MOP",
    state: "Maharastra",
    requirement_in_mt_: "0",
    availability_in_mt_: "46048.85",
    id: 595,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "NPK",
    state: "Maharastra",
    requirement_in_mt_: "0",
    availability_in_mt_: "192769.63",
    id: 596,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "TSP",
    state: "Maharastra",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 597,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "UREA",
    state: "Maharastra",
    requirement_in_mt_: "0",
    availability_in_mt_: "50657.8",
    id: 598,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "SSP",
    state: "Maharastra",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 599,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "DAP",
    state: "Manipur",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 600,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MAP",
    state: "Manipur",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 601,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MOP",
    state: "Manipur",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 602,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "NPK",
    state: "Manipur",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 603,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "TSP",
    state: "Manipur",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 604,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "UREA",
    state: "Manipur",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 605,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "SSP",
    state: "Manipur",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 606,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "DAP",
    state: "Megalaya",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 607,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MAP",
    state: "Megalaya",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 608,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MOP",
    state: "Megalaya",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 609,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "NPK",
    state: "Megalaya",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 610,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "TSP",
    state: "Megalaya",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 611,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "UREA",
    state: "Megalaya",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 612,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "SSP",
    state: "Megalaya",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 613,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "DAP",
    state: "Mizoram",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 614,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MAP",
    state: "Mizoram",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 615,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MOP",
    state: "Mizoram",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 616,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "NPK",
    state: "Mizoram",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 617,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "TSP",
    state: "Mizoram",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 618,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "UREA",
    state: "Mizoram",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 619,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "SSP",
    state: "Mizoram",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 620,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "DAP",
    state: "Nagaland",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 621,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MAP",
    state: "Nagaland",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 622,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MOP",
    state: "Nagaland",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 623,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "NPK",
    state: "Nagaland",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 624,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "TSP",
    state: "Nagaland",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 625,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "UREA",
    state: "Nagaland",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 626,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "SSP",
    state: "Nagaland",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 627,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "DAP",
    state: "Orissa",
    requirement_in_mt_: "0",
    availability_in_mt_: "8164.9",
    id: 628,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MAP",
    state: "Orissa",
    requirement_in_mt_: "0",
    availability_in_mt_: "8499.450000000001",
    id: 629,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MOP",
    state: "Orissa",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 630,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "NPK",
    state: "Orissa",
    requirement_in_mt_: "0",
    availability_in_mt_: "33092.2",
    id: 631,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "TSP",
    state: "Orissa",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 632,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "UREA",
    state: "Orissa",
    requirement_in_mt_: "0",
    availability_in_mt_: "14261.1",
    id: 633,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "SSP",
    state: "Orissa",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 634,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "DAP",
    state: "Pondicherry",
    requirement_in_mt_: "0",
    availability_in_mt_: "36",
    id: 635,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MAP",
    state: "Pondicherry",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 636,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MOP",
    state: "Pondicherry",
    requirement_in_mt_: "0",
    availability_in_mt_: "33.15",
    id: 637,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "NPK",
    state: "Pondicherry",
    requirement_in_mt_: "0",
    availability_in_mt_: "518.8",
    id: 638,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "TSP",
    state: "Pondicherry",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 639,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "UREA",
    state: "Pondicherry",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 640,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "SSP",
    state: "Pondicherry",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 641,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "DAP",
    state: "Punjab",
    requirement_in_mt_: "0",
    availability_in_mt_: "13501.1",
    id: 642,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MAP",
    state: "Punjab",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 643,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MOP",
    state: "Punjab",
    requirement_in_mt_: "0",
    availability_in_mt_: "23199.6",
    id: 644,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "NPK",
    state: "Punjab",
    requirement_in_mt_: "0",
    availability_in_mt_: "684.22",
    id: 645,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "TSP",
    state: "Punjab",
    requirement_in_mt_: "0",
    availability_in_mt_: "3355.3",
    id: 646,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "UREA",
    state: "Punjab",
    requirement_in_mt_: "0",
    availability_in_mt_: "8797.9",
    id: 647,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "SSP",
    state: "Punjab",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 648,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "DAP",
    state: "Rajasthan",
    requirement_in_mt_: "0",
    availability_in_mt_: "1216.85",
    id: 649,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MAP",
    state: "Rajasthan",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 650,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MOP",
    state: "Rajasthan",
    requirement_in_mt_: "0",
    availability_in_mt_: "3298.45",
    id: 651,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "NPK",
    state: "Rajasthan",
    requirement_in_mt_: "0",
    availability_in_mt_: "836.95",
    id: 652,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "TSP",
    state: "Rajasthan",
    requirement_in_mt_: "0",
    availability_in_mt_: "3526.25",
    id: 653,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "UREA",
    state: "Rajasthan",
    requirement_in_mt_: "0",
    availability_in_mt_: "3076.05",
    id: 654,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "SSP",
    state: "Rajasthan",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 655,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "DAP",
    state: "Tamil Nadu",
    requirement_in_mt_: "0",
    availability_in_mt_: "15972.4",
    id: 656,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MAP",
    state: "Tamil Nadu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 657,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MOP",
    state: "Tamil Nadu",
    requirement_in_mt_: "0",
    availability_in_mt_: "5848.8",
    id: 658,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "NPK",
    state: "Tamil Nadu",
    requirement_in_mt_: "0",
    availability_in_mt_: "32842.07",
    id: 659,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "TSP",
    state: "Tamil Nadu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 660,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "UREA",
    state: "Tamil Nadu",
    requirement_in_mt_: "0",
    availability_in_mt_: "240.08",
    id: 661,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "SSP",
    state: "Tamil Nadu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 662,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "DAP",
    state: "Telangana",
    requirement_in_mt_: "50000",
    availability_in_mt_: "10711.45",
    id: 663,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MAP",
    state: "Telangana",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 664,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MOP",
    state: "Telangana",
    requirement_in_mt_: "10000",
    availability_in_mt_: "8376.049999999999",
    id: 665,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "NPK",
    state: "Telangana",
    requirement_in_mt_: "95000",
    availability_in_mt_: "39575.67",
    id: 666,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "TSP",
    state: "Telangana",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 667,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "UREA",
    state: "Telangana",
    requirement_in_mt_: "160000",
    availability_in_mt_: "11160.9",
    id: 668,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "SSP",
    state: "Telangana",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 669,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "DAP",
    state: "Tripura",
    requirement_in_mt_: "0",
    availability_in_mt_: "3.55",
    id: 670,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MAP",
    state: "Tripura",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 671,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MOP",
    state: "Tripura",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 672,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "NPK",
    state: "Tripura",
    requirement_in_mt_: "0",
    availability_in_mt_: "5.65",
    id: 673,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "TSP",
    state: "Tripura",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 674,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "UREA",
    state: "Tripura",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 675,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "SSP",
    state: "Tripura",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 676,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "DAP",
    state: "Uttar Pradesh",
    requirement_in_mt_: "120000",
    availability_in_mt_: "88972.83",
    id: 677,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MAP",
    state: "Uttar Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 678,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MOP",
    state: "Uttar Pradesh",
    requirement_in_mt_: "12000",
    availability_in_mt_: "43005.35",
    id: 679,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "NPK",
    state: "Uttar Pradesh",
    requirement_in_mt_: "100000",
    availability_in_mt_: "32670.2",
    id: 680,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "TSP",
    state: "Uttar Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "16125.25",
    id: 681,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "UREA",
    state: "Uttar Pradesh",
    requirement_in_mt_: "500000",
    availability_in_mt_: "174901.95",
    id: 682,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "SSP",
    state: "Uttar Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 683,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "DAP",
    state: "Uttaranchal",
    requirement_in_mt_: "0",
    availability_in_mt_: "3571.65",
    id: 684,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MAP",
    state: "Uttaranchal",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 685,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MOP",
    state: "Uttaranchal",
    requirement_in_mt_: "0",
    availability_in_mt_: "0.3",
    id: 686,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "NPK",
    state: "Uttaranchal",
    requirement_in_mt_: "0",
    availability_in_mt_: "1679.5",
    id: 687,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "TSP",
    state: "Uttaranchal",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 688,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "UREA",
    state: "Uttaranchal",
    requirement_in_mt_: "0",
    availability_in_mt_: "4982.4",
    id: 689,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "SSP",
    state: "Uttaranchal",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 690,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "DAP",
    state: "West Bengal",
    requirement_in_mt_: "0",
    availability_in_mt_: "16301.96",
    id: 691,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MAP",
    state: "West Bengal",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 692,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "MOP",
    state: "West Bengal",
    requirement_in_mt_: "0",
    availability_in_mt_: "41809.7",
    id: 693,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "NPK",
    state: "West Bengal",
    requirement_in_mt_: "0",
    availability_in_mt_: "130624.78",
    id: 694,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "TSP",
    state: "West Bengal",
    requirement_in_mt_: "0",
    availability_in_mt_: "7377.55",
    id: 695,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "UREA",
    state: "West Bengal",
    requirement_in_mt_: "0",
    availability_in_mt_: "37071.19",
    id: 696,
  },
  {
    _year: "2015-2016",
    month: "June",
    product: "SSP",
    state: "West Bengal",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 697,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "DAP",
    state: "Andaman & Nicobar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 698,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MAP",
    state: "Andaman & Nicobar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 699,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MOP",
    state: "Andaman & Nicobar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 700,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "NPK",
    state: "Andaman & Nicobar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 701,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "TSP",
    state: "Andaman & Nicobar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 702,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "UREA",
    state: "Andaman & Nicobar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 703,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "SSP",
    state: "Andaman & Nicobar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 704,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "DAP",
    state: "Andhra Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "8554.469999999999",
    id: 705,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MAP",
    state: "Andhra Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 706,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MOP",
    state: "Andhra Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "13701.3",
    id: 707,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "NPK",
    state: "Andhra Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "48997.03",
    id: 708,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "TSP",
    state: "Andhra Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 709,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "UREA",
    state: "Andhra Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "14049.05",
    id: 710,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "SSP",
    state: "Andhra Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 711,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "DAP",
    state: "Arunachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 712,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MAP",
    state: "Arunachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 713,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MOP",
    state: "Arunachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 714,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "NPK",
    state: "Arunachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 715,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "TSP",
    state: "Arunachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 716,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "UREA",
    state: "Arunachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 717,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "SSP",
    state: "Arunachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 718,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "DAP",
    state: "Assam",
    requirement_in_mt_: "0",
    availability_in_mt_: "4548.75",
    id: 719,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MAP",
    state: "Assam",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 720,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MOP",
    state: "Assam",
    requirement_in_mt_: "0",
    availability_in_mt_: "1713.45",
    id: 721,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "NPK",
    state: "Assam",
    requirement_in_mt_: "0",
    availability_in_mt_: "3643.45",
    id: 722,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "TSP",
    state: "Assam",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 723,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "UREA",
    state: "Assam",
    requirement_in_mt_: "0",
    availability_in_mt_: "1151.4",
    id: 724,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "SSP",
    state: "Assam",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 725,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "DAP",
    state: "Bihar",
    requirement_in_mt_: "0",
    availability_in_mt_: "22472.65",
    id: 726,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MAP",
    state: "Bihar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 727,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MOP",
    state: "Bihar",
    requirement_in_mt_: "0",
    availability_in_mt_: "22866.7",
    id: 728,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "NPK",
    state: "Bihar",
    requirement_in_mt_: "0",
    availability_in_mt_: "49151",
    id: 729,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "TSP",
    state: "Bihar",
    requirement_in_mt_: "0",
    availability_in_mt_: "7673.75",
    id: 730,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "UREA",
    state: "Bihar",
    requirement_in_mt_: "0",
    availability_in_mt_: "11614.2",
    id: 731,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "SSP",
    state: "Bihar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 732,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "DAP",
    state: "Chandigarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 733,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MAP",
    state: "Chandigarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 734,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MOP",
    state: "Chandigarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 735,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "NPK",
    state: "Chandigarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 736,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "TSP",
    state: "Chandigarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 737,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "UREA",
    state: "Chandigarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 738,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "SSP",
    state: "Chandigarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 739,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "DAP",
    state: "Chattishgarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "19358.66",
    id: 740,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MAP",
    state: "Chattishgarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 741,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MOP",
    state: "Chattishgarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "14243.8",
    id: 742,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "NPK",
    state: "Chattishgarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "9676.84",
    id: 743,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "TSP",
    state: "Chattishgarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "3858.25",
    id: 744,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "UREA",
    state: "Chattishgarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "5004.75",
    id: 745,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "SSP",
    state: "Chattishgarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 746,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "DAP",
    state: "Dadra & Nagar Haveli",
    requirement_in_mt_: "0",
    availability_in_mt_: "493.8",
    id: 747,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MAP",
    state: "Dadra & Nagar Haveli",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 748,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MOP",
    state: "Dadra & Nagar Haveli",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 749,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "NPK",
    state: "Dadra & Nagar Haveli",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 750,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "TSP",
    state: "Dadra & Nagar Haveli",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 751,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "UREA",
    state: "Dadra & Nagar Haveli",
    requirement_in_mt_: "0",
    availability_in_mt_: "476.8",
    id: 752,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "SSP",
    state: "Dadra & Nagar Haveli",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 753,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "DAP",
    state: "Daman & Diu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 754,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MAP",
    state: "Daman & Diu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 755,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MOP",
    state: "Daman & Diu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 756,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "NPK",
    state: "Daman & Diu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 757,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "TSP",
    state: "Daman & Diu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 758,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "UREA",
    state: "Daman & Diu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 759,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "SSP",
    state: "Daman & Diu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 760,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "DAP",
    state: "Delhi",
    requirement_in_mt_: "800",
    availability_in_mt_: "0",
    id: 761,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MAP",
    state: "Delhi",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 762,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MOP",
    state: "Delhi",
    requirement_in_mt_: "200",
    availability_in_mt_: "0",
    id: 763,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "NPK",
    state: "Delhi",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 764,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "TSP",
    state: "Delhi",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 765,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "UREA",
    state: "Delhi",
    requirement_in_mt_: "900",
    availability_in_mt_: "0",
    id: 766,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "SSP",
    state: "Delhi",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 767,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "DAP",
    state: "Goa",
    requirement_in_mt_: "0",
    availability_in_mt_: "31.5",
    id: 768,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MAP",
    state: "Goa",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 769,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MOP",
    state: "Goa",
    requirement_in_mt_: "0",
    availability_in_mt_: "60.7",
    id: 770,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "NPK",
    state: "Goa",
    requirement_in_mt_: "0",
    availability_in_mt_: "45.9",
    id: 771,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "TSP",
    state: "Goa",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 772,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "UREA",
    state: "Goa",
    requirement_in_mt_: "0",
    availability_in_mt_: "17.25",
    id: 773,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "SSP",
    state: "Goa",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 774,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "DAP",
    state: "Gujarat",
    requirement_in_mt_: "0",
    availability_in_mt_: "22028.9",
    id: 775,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MAP",
    state: "Gujarat",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 776,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MOP",
    state: "Gujarat",
    requirement_in_mt_: "0",
    availability_in_mt_: "8230.450000000001",
    id: 777,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "NPK",
    state: "Gujarat",
    requirement_in_mt_: "0",
    availability_in_mt_: "28845.15",
    id: 778,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "TSP",
    state: "Gujarat",
    requirement_in_mt_: "0",
    availability_in_mt_: "6313.85",
    id: 779,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "UREA",
    state: "Gujarat",
    requirement_in_mt_: "0",
    availability_in_mt_: "7005.29",
    id: 780,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "SSP",
    state: "Gujarat",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 781,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "DAP",
    state: "Harayana",
    requirement_in_mt_: "0",
    availability_in_mt_: "15698.8",
    id: 782,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MAP",
    state: "Harayana",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 783,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MOP",
    state: "Harayana",
    requirement_in_mt_: "0",
    availability_in_mt_: "7334.5",
    id: 784,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "NPK",
    state: "Harayana",
    requirement_in_mt_: "0",
    availability_in_mt_: "1879.8",
    id: 785,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "TSP",
    state: "Harayana",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 786,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "UREA",
    state: "Harayana",
    requirement_in_mt_: "0",
    availability_in_mt_: "2772.95",
    id: 787,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "SSP",
    state: "Harayana",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 788,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "DAP",
    state: "Himachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 789,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MAP",
    state: "Himachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 790,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MOP",
    state: "Himachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 791,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "NPK",
    state: "Himachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "72.75",
    id: 792,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "TSP",
    state: "Himachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 793,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "UREA",
    state: "Himachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "93",
    id: 794,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "SSP",
    state: "Himachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 795,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "DAP",
    state: "Jammu & Kashmir",
    requirement_in_mt_: "0",
    availability_in_mt_: "6710.25",
    id: 796,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MAP",
    state: "Jammu & Kashmir",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 797,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MOP",
    state: "Jammu & Kashmir",
    requirement_in_mt_: "0",
    availability_in_mt_: "3812.8",
    id: 798,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "NPK",
    state: "Jammu & Kashmir",
    requirement_in_mt_: "0",
    availability_in_mt_: "67.5",
    id: 799,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "TSP",
    state: "Jammu & Kashmir",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 800,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "UREA",
    state: "Jammu & Kashmir",
    requirement_in_mt_: "0",
    availability_in_mt_: "1850.4",
    id: 801,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "SSP",
    state: "Jammu & Kashmir",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 802,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "DAP",
    state: "Jharkhand",
    requirement_in_mt_: "0",
    availability_in_mt_: "4310.45",
    id: 803,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MAP",
    state: "Jharkhand",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 804,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MOP",
    state: "Jharkhand",
    requirement_in_mt_: "0",
    availability_in_mt_: "486.45",
    id: 805,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "NPK",
    state: "Jharkhand",
    requirement_in_mt_: "0",
    availability_in_mt_: "6087.1",
    id: 806,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "TSP",
    state: "Jharkhand",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 807,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "UREA",
    state: "Jharkhand",
    requirement_in_mt_: "0",
    availability_in_mt_: "7800.7",
    id: 808,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "SSP",
    state: "Jharkhand",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 809,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "DAP",
    state: "Karnataka",
    requirement_in_mt_: "80000",
    availability_in_mt_: "32496.86",
    id: 810,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MAP",
    state: "Karnataka",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 811,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MOP",
    state: "Karnataka",
    requirement_in_mt_: "55000",
    availability_in_mt_: "31298.1",
    id: 812,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "NPK",
    state: "Karnataka",
    requirement_in_mt_: "130050",
    availability_in_mt_: "117328.81",
    id: 813,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "TSP",
    state: "Karnataka",
    requirement_in_mt_: "0",
    availability_in_mt_: "11884.85",
    id: 814,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "UREA",
    state: "Karnataka",
    requirement_in_mt_: "170000",
    availability_in_mt_: "19002.17",
    id: 815,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "SSP",
    state: "Karnataka",
    requirement_in_mt_: "10000",
    availability_in_mt_: "0",
    id: 816,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "DAP",
    state: "Kerala",
    requirement_in_mt_: "0",
    availability_in_mt_: "3572.65",
    id: 817,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MAP",
    state: "Kerala",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 818,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MOP",
    state: "Kerala",
    requirement_in_mt_: "0",
    availability_in_mt_: "5632.33",
    id: 819,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "NPK",
    state: "Kerala",
    requirement_in_mt_: "0",
    availability_in_mt_: "14810.3",
    id: 820,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "TSP",
    state: "Kerala",
    requirement_in_mt_: "0",
    availability_in_mt_: "3156.75",
    id: 821,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "UREA",
    state: "Kerala",
    requirement_in_mt_: "0",
    availability_in_mt_: "702.7",
    id: 822,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "SSP",
    state: "Kerala",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 823,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "DAP",
    state: "Madhya Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "46409.36",
    id: 824,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MAP",
    state: "Madhya Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 825,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MOP",
    state: "Madhya Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "24906.5",
    id: 826,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "NPK",
    state: "Madhya Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "12257.65",
    id: 827,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "TSP",
    state: "Madhya Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "8443.85",
    id: 828,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "UREA",
    state: "Madhya Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "11826",
    id: 829,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "SSP",
    state: "Madhya Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 830,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "DAP",
    state: "Maharastra",
    requirement_in_mt_: "0",
    availability_in_mt_: "25589.52",
    id: 831,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MAP",
    state: "Maharastra",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 832,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MOP",
    state: "Maharastra",
    requirement_in_mt_: "0",
    availability_in_mt_: "49035.25",
    id: 833,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "NPK",
    state: "Maharastra",
    requirement_in_mt_: "0",
    availability_in_mt_: "111090.23",
    id: 834,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "TSP",
    state: "Maharastra",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 835,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "UREA",
    state: "Maharastra",
    requirement_in_mt_: "0",
    availability_in_mt_: "14180",
    id: 836,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "SSP",
    state: "Maharastra",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 837,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "DAP",
    state: "Manipur",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 838,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MAP",
    state: "Manipur",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 839,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MOP",
    state: "Manipur",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 840,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "NPK",
    state: "Manipur",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 841,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "TSP",
    state: "Manipur",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 842,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "UREA",
    state: "Manipur",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 843,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "SSP",
    state: "Manipur",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 844,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "DAP",
    state: "Megalaya",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 845,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MAP",
    state: "Megalaya",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 846,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MOP",
    state: "Megalaya",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 847,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "NPK",
    state: "Megalaya",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 848,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "TSP",
    state: "Megalaya",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 849,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "UREA",
    state: "Megalaya",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 850,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "SSP",
    state: "Megalaya",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 851,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "DAP",
    state: "Mizoram",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 852,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MAP",
    state: "Mizoram",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 853,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MOP",
    state: "Mizoram",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 854,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "NPK",
    state: "Mizoram",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 855,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "TSP",
    state: "Mizoram",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 856,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "UREA",
    state: "Mizoram",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 857,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "SSP",
    state: "Mizoram",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 858,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "DAP",
    state: "Nagaland",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 859,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MAP",
    state: "Nagaland",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 860,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MOP",
    state: "Nagaland",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 861,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "NPK",
    state: "Nagaland",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 862,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "TSP",
    state: "Nagaland",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 863,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "UREA",
    state: "Nagaland",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 864,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "SSP",
    state: "Nagaland",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 865,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "DAP",
    state: "Orissa",
    requirement_in_mt_: "0",
    availability_in_mt_: "11335.39",
    id: 866,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MAP",
    state: "Orissa",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 867,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MOP",
    state: "Orissa",
    requirement_in_mt_: "0",
    availability_in_mt_: "9876.35",
    id: 868,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "NPK",
    state: "Orissa",
    requirement_in_mt_: "0",
    availability_in_mt_: "27082.22",
    id: 869,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "TSP",
    state: "Orissa",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 870,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "UREA",
    state: "Orissa",
    requirement_in_mt_: "0",
    availability_in_mt_: "8179.05",
    id: 871,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "SSP",
    state: "Orissa",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 872,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "DAP",
    state: "Pondicherry",
    requirement_in_mt_: "0",
    availability_in_mt_: "36",
    id: 873,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MAP",
    state: "Pondicherry",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 874,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MOP",
    state: "Pondicherry",
    requirement_in_mt_: "0",
    availability_in_mt_: "33.15",
    id: 875,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "NPK",
    state: "Pondicherry",
    requirement_in_mt_: "0",
    availability_in_mt_: "351.8",
    id: 876,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "TSP",
    state: "Pondicherry",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 877,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "UREA",
    state: "Pondicherry",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 878,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "SSP",
    state: "Pondicherry",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 879,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "DAP",
    state: "Punjab",
    requirement_in_mt_: "0",
    availability_in_mt_: "36722.65",
    id: 880,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MAP",
    state: "Punjab",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 881,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MOP",
    state: "Punjab",
    requirement_in_mt_: "0",
    availability_in_mt_: "19103.7",
    id: 882,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "NPK",
    state: "Punjab",
    requirement_in_mt_: "0",
    availability_in_mt_: "503.32",
    id: 883,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "TSP",
    state: "Punjab",
    requirement_in_mt_: "0",
    availability_in_mt_: "3355.3",
    id: 884,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "UREA",
    state: "Punjab",
    requirement_in_mt_: "0",
    availability_in_mt_: "5761.75",
    id: 885,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "SSP",
    state: "Punjab",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 886,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "DAP",
    state: "Rajasthan",
    requirement_in_mt_: "0",
    availability_in_mt_: "8711.92",
    id: 887,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MAP",
    state: "Rajasthan",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 888,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MOP",
    state: "Rajasthan",
    requirement_in_mt_: "0",
    availability_in_mt_: "2765.85",
    id: 889,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "NPK",
    state: "Rajasthan",
    requirement_in_mt_: "0",
    availability_in_mt_: "565.2",
    id: 890,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "TSP",
    state: "Rajasthan",
    requirement_in_mt_: "0",
    availability_in_mt_: "3526.25",
    id: 891,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "UREA",
    state: "Rajasthan",
    requirement_in_mt_: "0",
    availability_in_mt_: "1924.25",
    id: 892,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "SSP",
    state: "Rajasthan",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 893,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "DAP",
    state: "Tamil Nadu",
    requirement_in_mt_: "0",
    availability_in_mt_: "18493.1",
    id: 894,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MAP",
    state: "Tamil Nadu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 895,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MOP",
    state: "Tamil Nadu",
    requirement_in_mt_: "0",
    availability_in_mt_: "5520.9",
    id: 896,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "NPK",
    state: "Tamil Nadu",
    requirement_in_mt_: "0",
    availability_in_mt_: "37272.22",
    id: 897,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "TSP",
    state: "Tamil Nadu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 898,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "UREA",
    state: "Tamil Nadu",
    requirement_in_mt_: "0",
    availability_in_mt_: "1800.25",
    id: 899,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "SSP",
    state: "Tamil Nadu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 900,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "DAP",
    state: "Tripura",
    requirement_in_mt_: "0",
    availability_in_mt_: "3.55",
    id: 901,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MAP",
    state: "Tripura",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 902,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MOP",
    state: "Tripura",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 903,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "NPK",
    state: "Tripura",
    requirement_in_mt_: "0",
    availability_in_mt_: "5.65",
    id: 904,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "TSP",
    state: "Tripura",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 905,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "UREA",
    state: "Tripura",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 906,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "SSP",
    state: "Tripura",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 907,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "DAP",
    state: "Telangana",
    requirement_in_mt_: "40000",
    availability_in_mt_: "10992.95",
    id: 908,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MAP",
    state: "Telangana",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 909,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MOP",
    state: "Telangana",
    requirement_in_mt_: "25000",
    availability_in_mt_: "6420.88",
    id: 910,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "NPK",
    state: "Telangana",
    requirement_in_mt_: "105000",
    availability_in_mt_: "39439.34",
    id: 911,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "TSP",
    state: "Telangana",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 912,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "UREA",
    state: "Telangana",
    requirement_in_mt_: "150000",
    availability_in_mt_: "5816.2",
    id: 913,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "SSP",
    state: "Telangana",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 914,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "DAP",
    state: "Uttar Pradesh",
    requirement_in_mt_: "120000",
    availability_in_mt_: "139987.48",
    id: 915,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MAP",
    state: "Uttar Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 916,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MOP",
    state: "Uttar Pradesh",
    requirement_in_mt_: "10000",
    availability_in_mt_: "44565.25",
    id: 917,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "NPK",
    state: "Uttar Pradesh",
    requirement_in_mt_: "55000",
    availability_in_mt_: "22317.7",
    id: 918,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "TSP",
    state: "Uttar Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "16125.25",
    id: 919,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "UREA",
    state: "Uttar Pradesh",
    requirement_in_mt_: "450000",
    availability_in_mt_: "133668.25",
    id: 920,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "SSP",
    state: "Uttar Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 921,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "DAP",
    state: "Uttaranchal",
    requirement_in_mt_: "0",
    availability_in_mt_: "3054.8",
    id: 922,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MAP",
    state: "Uttaranchal",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 923,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MOP",
    state: "Uttaranchal",
    requirement_in_mt_: "0",
    availability_in_mt_: "0.3",
    id: 924,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "NPK",
    state: "Uttaranchal",
    requirement_in_mt_: "0",
    availability_in_mt_: "800.1",
    id: 925,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "TSP",
    state: "Uttaranchal",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 926,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "UREA",
    state: "Uttaranchal",
    requirement_in_mt_: "0",
    availability_in_mt_: "4362.35",
    id: 927,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "SSP",
    state: "Uttaranchal",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 928,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "DAP",
    state: "West Bengal",
    requirement_in_mt_: "0",
    availability_in_mt_: "12583.66",
    id: 929,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MAP",
    state: "West Bengal",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 930,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "MOP",
    state: "West Bengal",
    requirement_in_mt_: "0",
    availability_in_mt_: "30440.85",
    id: 931,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "NPK",
    state: "West Bengal",
    requirement_in_mt_: "0",
    availability_in_mt_: "127619.33",
    id: 932,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "TSP",
    state: "West Bengal",
    requirement_in_mt_: "0",
    availability_in_mt_: "7377.55",
    id: 933,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "UREA",
    state: "West Bengal",
    requirement_in_mt_: "0",
    availability_in_mt_: "9864.389999999999",
    id: 934,
  },
  {
    _year: "2015-2016",
    month: "July",
    product: "SSP",
    state: "West Bengal",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 935,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "DAP",
    state: "Andaman & Nicobar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 936,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MAP",
    state: "Andaman & Nicobar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 937,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MOP",
    state: "Andaman & Nicobar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 938,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "NPK",
    state: "Andaman & Nicobar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 939,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "TSP",
    state: "Andaman & Nicobar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 940,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "UREA",
    state: "Andaman & Nicobar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 941,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "SSP",
    state: "Andaman & Nicobar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 942,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "DAP",
    state: "Andhra Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "20854.17",
    id: 943,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MAP",
    state: "Andhra Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 944,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MOP",
    state: "Andhra Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "19181",
    id: 945,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "NPK",
    state: "Andhra Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "57956.76",
    id: 946,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "TSP",
    state: "Andhra Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 947,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "UREA",
    state: "Andhra Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "10137.7",
    id: 948,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "SSP",
    state: "Andhra Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 949,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "DAP",
    state: "Arunachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 950,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MAP",
    state: "Arunachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 951,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MOP",
    state: "Arunachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 952,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "NPK",
    state: "Arunachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 953,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "TSP",
    state: "Arunachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 954,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "UREA",
    state: "Arunachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 955,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "SSP",
    state: "Arunachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 956,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "DAP",
    state: "Assam",
    requirement_in_mt_: "0",
    availability_in_mt_: "3374.75",
    id: 957,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MAP",
    state: "Assam",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 958,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MOP",
    state: "Assam",
    requirement_in_mt_: "0",
    availability_in_mt_: "6328",
    id: 959,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "NPK",
    state: "Assam",
    requirement_in_mt_: "0",
    availability_in_mt_: "2813.65",
    id: 960,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "TSP",
    state: "Assam",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 961,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "UREA",
    state: "Assam",
    requirement_in_mt_: "0",
    availability_in_mt_: "799",
    id: 962,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "SSP",
    state: "Assam",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 963,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "DAP",
    state: "Bihar",
    requirement_in_mt_: "0",
    availability_in_mt_: "42483.2",
    id: 964,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MAP",
    state: "Bihar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 965,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MOP",
    state: "Bihar",
    requirement_in_mt_: "0",
    availability_in_mt_: "26252.95",
    id: 966,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "NPK",
    state: "Bihar",
    requirement_in_mt_: "0",
    availability_in_mt_: "58190.3",
    id: 967,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "TSP",
    state: "Bihar",
    requirement_in_mt_: "0",
    availability_in_mt_: "7673.75",
    id: 968,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "UREA",
    state: "Bihar",
    requirement_in_mt_: "0",
    availability_in_mt_: "5321.15",
    id: 969,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "SSP",
    state: "Bihar",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 970,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "DAP",
    state: "Chandigarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 971,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MAP",
    state: "Chandigarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 972,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MOP",
    state: "Chandigarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 973,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "NPK",
    state: "Chandigarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 974,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "TSP",
    state: "Chandigarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 975,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "UREA",
    state: "Chandigarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 976,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "SSP",
    state: "Chandigarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 977,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "DAP",
    state: "Chattishgarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "17988.66",
    id: 978,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MAP",
    state: "Chattishgarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 979,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MOP",
    state: "Chattishgarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "25447.25",
    id: 980,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "NPK",
    state: "Chattishgarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "6536.84",
    id: 981,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "TSP",
    state: "Chattishgarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "3858.25",
    id: 982,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "UREA",
    state: "Chattishgarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "5803.55",
    id: 983,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "SSP",
    state: "Chattishgarh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 984,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "DAP",
    state: "Dadra & Nagar Haveli",
    requirement_in_mt_: "0",
    availability_in_mt_: "19.8",
    id: 985,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MAP",
    state: "Dadra & Nagar Haveli",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 986,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MOP",
    state: "Dadra & Nagar Haveli",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 987,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "NPK",
    state: "Dadra & Nagar Haveli",
    requirement_in_mt_: "0",
    availability_in_mt_: "4.9",
    id: 988,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "TSP",
    state: "Dadra & Nagar Haveli",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 989,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "UREA",
    state: "Dadra & Nagar Haveli",
    requirement_in_mt_: "0",
    availability_in_mt_: "6",
    id: 990,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "SSP",
    state: "Dadra & Nagar Haveli",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 991,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "DAP",
    state: "Daman & Diu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 992,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MAP",
    state: "Daman & Diu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 993,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MOP",
    state: "Daman & Diu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 994,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "NPK",
    state: "Daman & Diu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 995,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "TSP",
    state: "Daman & Diu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 996,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "UREA",
    state: "Daman & Diu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 997,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "SSP",
    state: "Daman & Diu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 998,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "DAP",
    state: "Delhi",
    requirement_in_mt_: "400",
    availability_in_mt_: "0",
    id: 999,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MAP",
    state: "Delhi",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1000,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MOP",
    state: "Delhi",
    requirement_in_mt_: "100",
    availability_in_mt_: "0",
    id: 1001,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "NPK",
    state: "Delhi",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1002,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "TSP",
    state: "Delhi",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1003,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "UREA",
    state: "Delhi",
    requirement_in_mt_: "300",
    availability_in_mt_: "0",
    id: 1004,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "SSP",
    state: "Delhi",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1005,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "DAP",
    state: "Goa",
    requirement_in_mt_: "0",
    availability_in_mt_: "21.3",
    id: 1006,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MAP",
    state: "Goa",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1007,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MOP",
    state: "Goa",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1008,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "NPK",
    state: "Goa",
    requirement_in_mt_: "0",
    availability_in_mt_: "11.4",
    id: 1009,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "TSP",
    state: "Goa",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1010,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "UREA",
    state: "Goa",
    requirement_in_mt_: "0",
    availability_in_mt_: "7.2",
    id: 1011,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "SSP",
    state: "Goa",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1012,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "DAP",
    state: "Gujarat",
    requirement_in_mt_: "0",
    availability_in_mt_: "44507.93",
    id: 1013,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MAP",
    state: "Gujarat",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1014,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MOP",
    state: "Gujarat",
    requirement_in_mt_: "0",
    availability_in_mt_: "2594.55",
    id: 1015,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "NPK",
    state: "Gujarat",
    requirement_in_mt_: "0",
    availability_in_mt_: "38914.2",
    id: 1016,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "TSP",
    state: "Gujarat",
    requirement_in_mt_: "0",
    availability_in_mt_: "6313.85",
    id: 1017,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "UREA",
    state: "Gujarat",
    requirement_in_mt_: "0",
    availability_in_mt_: "7151.19",
    id: 1018,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "SSP",
    state: "Gujarat",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1019,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "DAP",
    state: "Harayana",
    requirement_in_mt_: "0",
    availability_in_mt_: "29736",
    id: 1020,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MAP",
    state: "Harayana",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1021,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MOP",
    state: "Harayana",
    requirement_in_mt_: "0",
    availability_in_mt_: "8481.25",
    id: 1022,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "NPK",
    state: "Harayana",
    requirement_in_mt_: "0",
    availability_in_mt_: "4103.9",
    id: 1023,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "TSP",
    state: "Harayana",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1024,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "UREA",
    state: "Harayana",
    requirement_in_mt_: "0",
    availability_in_mt_: "7914.45",
    id: 1025,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "SSP",
    state: "Harayana",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1026,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "DAP",
    state: "Himachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1027,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MAP",
    state: "Himachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1028,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MOP",
    state: "Himachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1029,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "NPK",
    state: "Himachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "26.35",
    id: 1030,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "TSP",
    state: "Himachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1031,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "UREA",
    state: "Himachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "86.15000000000001",
    id: 1032,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "SSP",
    state: "Himachal Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1033,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "DAP",
    state: "Jammu & Kashmir",
    requirement_in_mt_: "0",
    availability_in_mt_: "4946.05",
    id: 1034,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MAP",
    state: "Jammu & Kashmir",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1035,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MOP",
    state: "Jammu & Kashmir",
    requirement_in_mt_: "0",
    availability_in_mt_: "3638.8",
    id: 1036,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "NPK",
    state: "Jammu & Kashmir",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1037,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "TSP",
    state: "Jammu & Kashmir",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1038,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "UREA",
    state: "Jammu & Kashmir",
    requirement_in_mt_: "0",
    availability_in_mt_: "550.5",
    id: 1039,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "SSP",
    state: "Jammu & Kashmir",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1040,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "DAP",
    state: "Jharkhand",
    requirement_in_mt_: "0",
    availability_in_mt_: "4298.1",
    id: 1041,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MAP",
    state: "Jharkhand",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1042,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MOP",
    state: "Jharkhand",
    requirement_in_mt_: "0",
    availability_in_mt_: "1474.95",
    id: 1043,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "NPK",
    state: "Jharkhand",
    requirement_in_mt_: "0",
    availability_in_mt_: "6400.45",
    id: 1044,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "TSP",
    state: "Jharkhand",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1045,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "UREA",
    state: "Jharkhand",
    requirement_in_mt_: "0",
    availability_in_mt_: "5779.6",
    id: 1046,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "SSP",
    state: "Jharkhand",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1047,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "DAP",
    state: "Karnataka",
    requirement_in_mt_: "60000",
    availability_in_mt_: "42857.67",
    id: 1048,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MAP",
    state: "Karnataka",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1049,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MOP",
    state: "Karnataka",
    requirement_in_mt_: "30000",
    availability_in_mt_: "48996.36",
    id: 1050,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "NPK",
    state: "Karnataka",
    requirement_in_mt_: "152500",
    availability_in_mt_: "122920.28",
    id: 1051,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "TSP",
    state: "Karnataka",
    requirement_in_mt_: "0",
    availability_in_mt_: "11884.85",
    id: 1052,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "UREA",
    state: "Karnataka",
    requirement_in_mt_: "160000",
    availability_in_mt_: "10690.97",
    id: 1053,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "SSP",
    state: "Karnataka",
    requirement_in_mt_: "20000",
    availability_in_mt_: "0",
    id: 1054,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "DAP",
    state: "Kerala",
    requirement_in_mt_: "0",
    availability_in_mt_: "3572.35",
    id: 1055,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MAP",
    state: "Kerala",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1056,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MOP",
    state: "Kerala",
    requirement_in_mt_: "0",
    availability_in_mt_: "7591.67",
    id: 1057,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "NPK",
    state: "Kerala",
    requirement_in_mt_: "0",
    availability_in_mt_: "13582.43",
    id: 1058,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "TSP",
    state: "Kerala",
    requirement_in_mt_: "0",
    availability_in_mt_: "3156.75",
    id: 1059,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "UREA",
    state: "Kerala",
    requirement_in_mt_: "0",
    availability_in_mt_: "1994.95",
    id: 1060,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "SSP",
    state: "Kerala",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1061,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "DAP",
    state: "Lakshadweep",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1062,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MAP",
    state: "Lakshadweep",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1063,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MOP",
    state: "Lakshadweep",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1064,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "NPK",
    state: "Lakshadweep",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1065,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "TSP",
    state: "Lakshadweep",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1066,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "UREA",
    state: "Lakshadweep",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1067,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "SSP",
    state: "Lakshadweep",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1068,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "DAP",
    state: "Madhya Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "123474.96",
    id: 1069,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MAP",
    state: "Madhya Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1070,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MOP",
    state: "Madhya Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "36360.95",
    id: 1071,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "NPK",
    state: "Madhya Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "20406.9",
    id: 1072,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "TSP",
    state: "Madhya Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "8443.85",
    id: 1073,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "UREA",
    state: "Madhya Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "32996",
    id: 1074,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "SSP",
    state: "Madhya Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1075,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "DAP",
    state: "Maharastra",
    requirement_in_mt_: "0",
    availability_in_mt_: "56520.52",
    id: 1076,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MAP",
    state: "Maharastra",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1077,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MOP",
    state: "Maharastra",
    requirement_in_mt_: "0",
    availability_in_mt_: "74183.7",
    id: 1078,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "NPK",
    state: "Maharastra",
    requirement_in_mt_: "0",
    availability_in_mt_: "173441.08",
    id: 1079,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "TSP",
    state: "Maharastra",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1080,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "UREA",
    state: "Maharastra",
    requirement_in_mt_: "0",
    availability_in_mt_: "30667.7",
    id: 1081,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "SSP",
    state: "Maharastra",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1082,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "DAP",
    state: "Manipur",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1083,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MAP",
    state: "Manipur",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1084,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MOP",
    state: "Manipur",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1085,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "NPK",
    state: "Manipur",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1086,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "TSP",
    state: "Manipur",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1087,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "UREA",
    state: "Manipur",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1088,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "SSP",
    state: "Manipur",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1089,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "DAP",
    state: "Megalaya",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1090,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MAP",
    state: "Megalaya",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1091,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MOP",
    state: "Megalaya",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1092,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "NPK",
    state: "Megalaya",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1093,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "TSP",
    state: "Megalaya",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1094,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "UREA",
    state: "Megalaya",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1095,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "SSP",
    state: "Megalaya",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1096,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "DAP",
    state: "Mizoram",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1097,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MAP",
    state: "Mizoram",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1098,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MOP",
    state: "Mizoram",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1099,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "NPK",
    state: "Mizoram",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1100,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "TSP",
    state: "Mizoram",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1101,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "UREA",
    state: "Mizoram",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1102,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "SSP",
    state: "Mizoram",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1103,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "DAP",
    state: "Nagaland",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1104,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MAP",
    state: "Nagaland",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1105,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MOP",
    state: "Nagaland",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1106,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "NPK",
    state: "Nagaland",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1107,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "TSP",
    state: "Nagaland",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1108,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "UREA",
    state: "Nagaland",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1109,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "SSP",
    state: "Nagaland",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1110,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "DAP",
    state: "Orissa",
    requirement_in_mt_: "0",
    availability_in_mt_: "11521.89",
    id: 1111,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MAP",
    state: "Orissa",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1112,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MOP",
    state: "Orissa",
    requirement_in_mt_: "0",
    availability_in_mt_: "9659.25",
    id: 1113,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "NPK",
    state: "Orissa",
    requirement_in_mt_: "0",
    availability_in_mt_: "27256.37",
    id: 1114,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "TSP",
    state: "Orissa",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1115,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "UREA",
    state: "Orissa",
    requirement_in_mt_: "0",
    availability_in_mt_: "8300.9",
    id: 1116,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "SSP",
    state: "Orissa",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1117,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "DAP",
    state: "Pondicherry",
    requirement_in_mt_: "0",
    availability_in_mt_: "36",
    id: 1118,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MAP",
    state: "Pondicherry",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1119,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MOP",
    state: "Pondicherry",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1120,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "NPK",
    state: "Pondicherry",
    requirement_in_mt_: "0",
    availability_in_mt_: "230.8",
    id: 1121,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "TSP",
    state: "Pondicherry",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1122,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "UREA",
    state: "Pondicherry",
    requirement_in_mt_: "0",
    availability_in_mt_: "50",
    id: 1123,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "SSP",
    state: "Pondicherry",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1124,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "DAP",
    state: "Punjab",
    requirement_in_mt_: "0",
    availability_in_mt_: "34289.25",
    id: 1125,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MAP",
    state: "Punjab",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1126,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MOP",
    state: "Punjab",
    requirement_in_mt_: "0",
    availability_in_mt_: "27644.45",
    id: 1127,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "NPK",
    state: "Punjab",
    requirement_in_mt_: "0",
    availability_in_mt_: "767.92",
    id: 1128,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "TSP",
    state: "Punjab",
    requirement_in_mt_: "0",
    availability_in_mt_: "3355.3",
    id: 1129,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "UREA",
    state: "Punjab",
    requirement_in_mt_: "0",
    availability_in_mt_: "7674.55",
    id: 1130,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "SSP",
    state: "Punjab",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1131,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "DAP",
    state: "Rajasthan",
    requirement_in_mt_: "0",
    availability_in_mt_: "10711.17",
    id: 1132,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MAP",
    state: "Rajasthan",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1133,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MOP",
    state: "Rajasthan",
    requirement_in_mt_: "0",
    availability_in_mt_: "2517.3",
    id: 1134,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "NPK",
    state: "Rajasthan",
    requirement_in_mt_: "0",
    availability_in_mt_: "494.65",
    id: 1135,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "TSP",
    state: "Rajasthan",
    requirement_in_mt_: "0",
    availability_in_mt_: "3526.25",
    id: 1136,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "UREA",
    state: "Rajasthan",
    requirement_in_mt_: "0",
    availability_in_mt_: "5817.4",
    id: 1137,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "SSP",
    state: "Rajasthan",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1138,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "DAP",
    state: "Sikkim",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1139,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MAP",
    state: "Sikkim",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1140,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MOP",
    state: "Sikkim",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1141,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "NPK",
    state: "Sikkim",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1142,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "TSP",
    state: "Sikkim",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1143,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "UREA",
    state: "Sikkim",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1144,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "SSP",
    state: "Sikkim",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1145,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "DAP",
    state: "Tamil Nadu",
    requirement_in_mt_: "0",
    availability_in_mt_: "13861.3",
    id: 1146,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MAP",
    state: "Tamil Nadu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1147,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MOP",
    state: "Tamil Nadu",
    requirement_in_mt_: "0",
    availability_in_mt_: "4163",
    id: 1148,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "NPK",
    state: "Tamil Nadu",
    requirement_in_mt_: "0",
    availability_in_mt_: "33547.92",
    id: 1149,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "TSP",
    state: "Tamil Nadu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1150,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "UREA",
    state: "Tamil Nadu",
    requirement_in_mt_: "0",
    availability_in_mt_: "92.7",
    id: 1151,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "SSP",
    state: "Tamil Nadu",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1152,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "DAP",
    state: "Tripura",
    requirement_in_mt_: "0",
    availability_in_mt_: "1.95",
    id: 1153,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MAP",
    state: "Tripura",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1154,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MOP",
    state: "Tripura",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1155,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "NPK",
    state: "Tripura",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1156,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "TSP",
    state: "Tripura",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1157,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "UREA",
    state: "Tripura",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1158,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "SSP",
    state: "Tripura",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1159,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "DAP",
    state: "Telangana",
    requirement_in_mt_: "30000",
    availability_in_mt_: "9590.799999999999",
    id: 1160,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MAP",
    state: "Telangana",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1161,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MOP",
    state: "Telangana",
    requirement_in_mt_: "30000",
    availability_in_mt_: "8640.629999999999",
    id: 1162,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "NPK",
    state: "Telangana",
    requirement_in_mt_: "100000",
    availability_in_mt_: "51061.45",
    id: 1163,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "TSP",
    state: "Telangana",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1164,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "UREA",
    state: "Telangana",
    requirement_in_mt_: "200000",
    availability_in_mt_: "3898.9",
    id: 1165,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "SSP",
    state: "Telangana",
    requirement_in_mt_: "15000",
    availability_in_mt_: "0",
    id: 1166,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "DAP",
    state: "Uttar Pradesh",
    requirement_in_mt_: "110000",
    availability_in_mt_: "224299.33",
    id: 1167,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MAP",
    state: "Uttar Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1168,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MOP",
    state: "Uttar Pradesh",
    requirement_in_mt_: "10000",
    availability_in_mt_: "56627.75",
    id: 1169,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "NPK",
    state: "Uttar Pradesh",
    requirement_in_mt_: "50000",
    availability_in_mt_: "50379.55",
    id: 1170,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "TSP",
    state: "Uttar Pradesh",
    requirement_in_mt_: "0",
    availability_in_mt_: "16125.25",
    id: 1171,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "UREA",
    state: "Uttar Pradesh",
    requirement_in_mt_: "400000",
    availability_in_mt_: "73126.89999999999",
    id: 1172,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "DAP",
    state: "Uttaranchal",
    requirement_in_mt_: "0",
    availability_in_mt_: "2625.75",
    id: 1173,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MAP",
    state: "Uttaranchal",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1174,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "MOP",
    state: "Uttaranchal",
    requirement_in_mt_: "0",
    availability_in_mt_: "0.3",
    id: 1175,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "NPK",
    state: "Uttaranchal",
    requirement_in_mt_: "0",
    availability_in_mt_: "2394.65",
    id: 1176,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "TSP",
    state: "Uttaranchal",
    requirement_in_mt_: "0",
    availability_in_mt_: "1254.75",
    id: 1177,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "UREA",
    state: "Uttaranchal",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1178,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "SSP",
    state: "Uttaranchal",
    requirement_in_mt_: "0",
    availability_in_mt_: "0",
    id: 1179,
  },
  {
    _year: "2015-2016",
    month: "August",
    product: "DAP",
    state: "West Bengal",
    requirement_in_mt_: "0",
    availability_in_mt_: "33454.86",
    id: 1180,
  },
]
